import _debounce from "lodash/debounce";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Icon, Input } from "semantic-ui-react";

import { setSearchTerm as setQuerySearchTerm, useSearchTerm } from "components/NavBarSearch/hooks";
import "components/NavBarSearch/NavBarSearch.scss";

type NavBarSearchProps = {
  children?: React.ReactNode;
};

export const NavBarSearch = ({ children }: NavBarSearchProps) => {
  const { t } = useTranslation();

  const cacheSearchTerm = useSearchTerm();
  const [searchTerm, setSearchTerm] = useState(cacheSearchTerm);

  useEffect(() => {
    if (!cacheSearchTerm && searchTerm) setSearchTerm("");
  }, [cacheSearchTerm]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setQuerySearchTerm(e.target.value);
  };

  return (
    <div className="NavBarSearch">
      <Input
        icon={<Icon className="magnifying glass" />}
        iconPosition="left"
        placeholder={`${t("v8_search", "Search")}...`}
        className="nav-bar-search"
        onChange={handleSearchChange}
        value={searchTerm}
        id="NavBarSearchInput"
      />
      {children}
    </div>
  );
};
